import React from "react";
import { withTranslation } from "react-i18next";
import { Face1, Face2 } from "../components/animations/instructions";
import { router } from "../utilis/router/router";

class Instructions extends React.Component {
    constructor(props) {
        super(props);
        const first = { id: 0, component: <Face1 />, text: "", active: true };
        this.state = {
            steps: [
                first,
                { id: 1, component: <Face2 />, text: "" }
            ],
            currect: first
        };

        this.on = {
            click: (item) => {
                const steps = [...this.state.steps];
                steps.forEach(el => {
                    el.active = el.id === item.id;
                });
                this.setState({ currect: item, steps });
            }
        };
    }

    render() {
        const { t } = this.props;
        return (
            <section className="text-gray-700 body-font">
                <div className="container px-5 py-5 mx-auto flex flex-wrap flex-col">
                    <div className="flex mx-auto flex-wrap mb-20">
                        {this.state.steps.map((item, index) => (
                            <span
                                key={index}
                                onClick={() => this.on.click(item)}
                                className={(item.active ? "border-blue-900 text-blue-900 " : "") +
                                    "sm:px-6 py-3 w-1/2 sm:w-auto justify-center sm:justify-start border-b-2 title-font font-medium bg-gray-100 inline-flex items-center leading-none tracking-wider rounded-t"}
                            >
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            </svg>
                                {t("step")} {index + 1}
                        </span>
                        ))}
                    </div>
                    <div className="xl:w-1/4 lg:w-1/3 md:w-1/2 w-2/3 block mx-auto mb-10 object-cover object-center rounded">
                        {this.state.currect.component}
                    </div>
                    <div className="flex flex-col text-center w-full">
                        <h1 className="text-xl font-medium title-font mb-4 text-gray-900">
                            {t(this.state.currect.text)}
                        </h1>
                    </div>
                </div>
                <div className="z-10 xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
                    {
                        this.state.currect.id === 0 ?
                            <button
                                onClick={() => { router.dispatch("instructions"); }}
                                className="mx-auto flashing relative z-10 font-semibold text-lg hover:bg-red-400 bg-red-600 text-white py-3 px-12 rounded-full"
                            >
                                {t("btn_next")}
                            </button>
                            :
                            <button
                                onClick={() => { router.dispatch("instructions"); }}
                                className="mx-auto flashing relative z-10 font-semibold text-lg hover:bg-red-400 bg-red-600 text-white py-3 px-12 rounded-full"
                            >
                                {t("btn_apply")}
                            </button>
                    }
                </div>
            </section>
        );
    }

}

export default withTranslation()(Instructions);
